import { useNavigate, useLocation } from 'react-router-dom';
import { CreateEventForm } from '@/components/CreateEventForm';
import { Event } from '@/types/event';
import { toast } from 'sonner';
import NavigationBar from '@/components/NavigationBar';

const CreateEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const templateData = location.state?.template;
  const familyGroupId = location.state?.familyGroupId;
  const familyGroupName = location.state?.familyGroupName;

  const handleEventCreated = (event: Event) => {
    toast.success('Event created successfully!');
    // Navigate to dashboard or event details
    navigate('/dashboard');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <>
      <NavigationBar />
      <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-secondary/10">
        <CreateEventForm 
          onEventCreated={handleEventCreated} 
          onBack={handleBack} 
          templateData={templateData}
          familyGroupId={familyGroupId}
          familyGroupName={familyGroupName}
        />
      </div>
    </>
  );
};

export default CreateEvent;